import React, { useEffect, useState } from 'react'
import './navbar.scss'

function Navbar() {
  const [sticky, setSticky] = useState(false);
  const [isNavMenuActive, setIsNavMenuActive] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, [])

  const handleScroll = (e) => {
    if (window.pageYOffset > 30) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  }

  const toggleNavMenu = () => {
    setIsNavMenuActive(!isNavMenuActive);
  }

  return (
    <nav className={"_navbar " + (sticky && "sticky")}>
      <div className="max-width">
        <div className="logo">
          <a href="#">Portfo<span>lio.</span></a>
        </div>
        <ul className={"menu " + (isNavMenuActive && "active")} >
          <li><a href="#home" >Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#skills">Skills</a></li>
          <li><a href="#projects">Projects</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
        <div onClick={toggleNavMenu} class="menu-btn">
          <i class="fas fa-bars"></i>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
